import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

// Start every new page at the top, before it paints. This is a jump, not a
// smooth scroll: an animated reset is easily cancelled on phones (touch
// momentum, images loading) and left visitors stranded at the footer.
// Links with a #hash scroll to their own section, so they are left alone.
export default function ScrollToTop() {
    const { pathname, hash } = useLocation();

    useLayoutEffect(() => {
        if (!hash) window.scrollTo(0, 0);
    }, [pathname, hash]);

    return null;
}
